import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
const Root = t0 => {
  const $ = _c(6);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      dir: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const dir = t1 === undefined ? "rtl" : t1;
  let t2;
  if ($[3] !== dir || $[4] !== props) {
    t2 = <DropdownMenuPrimitive.Root dir={dir} {...props} />;
    $[3] = dir;
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
const Trigger = DropdownMenuPrimitive.Trigger;
const Portal = DropdownMenuPrimitive.Portal;
const Content = t0 => {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      align: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const align = t1 === undefined ? "start" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("py-12 shadow-xl", "data-[state=open]:animate-in data-[state=closed]:animate-out", "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95", "data-[side=bottom]:slide-in-from-top-2", "data-[side=left]:slide-in-from-right-2", "data-[side=right]:slide-in-from-left-2", "data-[side=top]:slide-in-from-bottom-2", "duration-200 motion-reduce:animate-none", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== align || $[7] !== props || $[8] !== t2) {
    t3 = <DropdownMenuPrimitive.Content align={align} className={t2} {...props} />;
    $[6] = align;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
const Label = DropdownMenuPrimitive.Label;
const Item = t0 => {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      dir: t1,
      role: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const dir = t1 === undefined ? "ltr" : t1;
  const role = t2 === undefined ? "button" : t2;
  let t3;
  if ($[5] !== className) {
    t3 = cn("relative flex cursor-pointer select-none items-center px-16 py-8 font-400 outline-none typo-body3", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", "hover:bg-B-50 focus:bg-B-50", "data-[highlighted]:bg-B-50", "transition-colors duration-200", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== dir || $[8] !== props || $[9] !== role || $[10] !== t3) {
    t4 = <DropdownMenuPrimitive.Item className={t3} dir={dir} role={role} {...props} />;
    $[7] = dir;
    $[8] = props;
    $[9] = role;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
const Group = DropdownMenuPrimitive.Group;
const CheckboxItem = DropdownMenuPrimitive.CheckboxItem;
const ItemIndicator = DropdownMenuPrimitive.ItemIndicator;
const RadioGroup = DropdownMenuPrimitive.RadioGroup;
const RadioItem = DropdownMenuPrimitive.RadioItem;
const Sub = DropdownMenuPrimitive.Sub;
const SubTrigger = DropdownMenuPrimitive.SubTrigger;
const SubContent = DropdownMenuPrimitive.SubContent;
const Separator = DropdownMenuPrimitive.Separator;
const Arrow = DropdownMenuPrimitive.Arrow;

/**
 * @deprecated organism 에 있는 DropdownMenu 를 사용해주세요
 */
export const Dropdown = {
  Root,
  Trigger,
  Portal,
  Content,
  Label,
  Item,
  Group,
  CheckboxItem,
  ItemIndicator,
  RadioGroup,
  RadioItem,
  Sub,
  SubTrigger,
  SubContent,
  Separator,
  Arrow
};